import { useAuth } from '../contexts/AuthContext';
import type { ViewMode } from '../api/auth';

/**
 * Hook that returns the current user's view mode.
 *
 * - `simplified` (default for new accounts) hides power-user UI: AI provider picker,
 *   raw OCR markdown, classification internals, document-version metadata,
 *   per-card OCR/classify reprocess buttons, NER advanced toggles, debug telemetry,
 *   E2EE key rotation, passkey internals, etc.
 * - `advanced` shows everything (current pre-Jun-2026 behaviour).
 *
 * Unauthenticated / loading users get `simplified` so the more accessible UI is
 * the safe default.
 */
export const useViewMode = (): ViewMode => {
  const { user } = useAuth();
  return user?.view_mode === 'advanced' ? 'advanced' : 'simplified';
};

/** Convenience: `true` when the user has opted into the full power-user UI. */
export const useIsAdvanced = (): boolean => useViewMode() === 'advanced';
